<template>
  <section  v-if="contractInfo.subscriptionType !== 'MOBILE_PREPAID'" class="subscription-section" :class="{'full-width': $props.fullWidth}">
    <p class="desc" v-if="contractInfo.subscriptionState === 'EXPIRED_CONTRACT_OBLIGATION'">
      {{ $t('contractObligation.obligationExpired') }}
      <span class="value" v-if="false">{{ contractInfo.formattedContractEndDate }}</span>
    </p>
    <p class="desc" v-else-if="contractInfo.subscriptionState === 'ONGOING_CONTRACT_OBLIGATION' || contractInfo.subscriptionState === 'ONGOING_CONTRACT_OBLIGATION_3_MONTHS_BEFORE_EXPIRATION'">
      {{ $t('contractObligation.obligationOngoing') }}
      <span class="value">{{ contractInfo.formattedContractEndDate }}</span>
    </p>
    <p class="desc" v-else>
      {{ $t('contractObligation.obligationDoesntExist') }}
    </p>
  </section>
</template>

<script>

export default {
  name: 'contract-obligation-bar',
  props: {
    contractInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fullWidth: Boolean
  }
}
</script>

<style scoped lang="scss">
.subscription-section {
  padding: 2rem 0;

  &:not(.full-width) {
    @media (map_get($breakpoints, lg)) {
      width: 65%;
      max-width: 580px;
      //padding: 2rem 2rem 0 0;
    }

    @media (map_get($breakpoints, xxl)) {
      width: 100%;
      max-width: 935px;
    }
  }

  .desc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.6rem;
    font-weight: 600;
    color: $text;
    margin: 0;
    background-color: $white;
    padding: 1.6rem;
    border-radius: 5px;
  }

  .value {
    color: $primary;
    margin-left: 1rem;
  }
}
</style>
